(function () {
  var containerSelector = '[data-infinite-scroll-container]';
  var gridSelector = '[data-infinite-scroll-grid]';
  var paginationSelector = '[data-infinite-scroll-pagination]';
  var statusSelector = '[data-infinite-scroll-status]';
  var readyAttribute = 'data-infinite-scroll-ready';

  function initAll(context) {
    var scope = context || document;
    var containers = scope.querySelectorAll(containerSelector + ':not([' + readyAttribute + '])');

    Array.prototype.forEach.call(containers, function (container) {
      new CollectionInfiniteScroll(container);
    });
  }

  function CollectionInfiniteScroll(container) {
    this.container = container;
    this.grid = container.querySelector(gridSelector);
    this.collectionProducts = container.closest('.CollectionInner__Products') || document;
    this.pagination = this.collectionProducts.querySelector(paginationSelector);
    this.status = this.collectionProducts.querySelector(statusSelector);
    this.nextUrl = this.getNextUrl(this.pagination);
    this.loading = false;
    this.observer = null;

    container.setAttribute(readyAttribute, 'true');

    if (!this.grid || !this.pagination || !this.status || !this.nextUrl || !('IntersectionObserver' in window)) {
      return;
    }

    this.pagination.classList.add('is-hidden');
    this.observe();
  }

  CollectionInfiniteScroll.prototype.getNextUrl = function (pagination) {
    var nextLink = pagination ? pagination.querySelector('a[rel="next"]') : null;

    if (!nextLink) {
      return null;
    }

    var nextUrl = nextLink.getAttribute('href');

    return new URL(nextUrl, window.location.origin).toString();
  };

  CollectionInfiniteScroll.prototype.observe = function () {
    var self = this;

    this.observer = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) {
        self.loadNextPage();
      }
    }, {
      rootMargin: '700px 0px'
    });

    this.observer.observe(this.status);
  };

  CollectionInfiniteScroll.prototype.loadNextPage = function () {
    var self = this;

    if (this.loading || !this.nextUrl) {
      return;
    }

    this.loading = true;
    this.status.classList.add('is-loading');

    fetch(this.nextUrl, {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to load next collection page');
        }

        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector(gridSelector);
        var nextPagination = doc.querySelector(paginationSelector);
        var nextItems = nextGrid ? Array.prototype.slice.call(nextGrid.children) : [];

        nextItems.forEach(function (item) {
          self.grid.appendChild(document.importNode(item, true));
        });

        self.nextUrl = self.getNextUrl(nextPagination);
        self.refreshProductEnhancements(nextItems);

        if (!self.nextUrl) {
          self.finish();
        }
      })
      .catch(function () {
        self.pagination.classList.remove('is-hidden');
        self.finish();
      })
      .finally(function () {
        self.loading = false;
        self.status.classList.remove('is-loading');
      });
  };

  CollectionInfiniteScroll.prototype.refreshProductEnhancements = function (items) {
    if (window.ProductItemColorSwatch) {
      new window.ProductItemColorSwatch(this.grid);
    }

    document.dispatchEvent(new CustomEvent('boneur:collection:items-loaded', {
      detail: {
        items: items
      }
    }));
  };

  CollectionInfiniteScroll.prototype.finish = function () {
    this.nextUrl = null;

    if (this.observer) {
      this.observer.disconnect();
    }
  };

  function scheduleInit() {
    window.requestAnimationFrame(function () {
      initAll(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  new MutationObserver(scheduleInit).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
